import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Features from './components/Features';
import PopularComics from './components/PopularComics';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <PopularComics />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </>
  );
}